var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('bar-chart',{attrs:{"xdata":_vm.xdata,"series":_vm.series,"unit":'￥',"type":'age'}}),_c('p',{staticClass:"charttips"},[_vm._v("说明：图示为所选统计区间各年龄组赔付金额")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }